import { useLazyQuery, useQuery } from "@apollo/client";
import { useState, createContext, useContext, useEffect, useMemo } from "react";
import { GET_ALL_USERS, GET_ME } from "services/apollo/Queries";
import { useDispatch } from "react-redux";
import { setAllUsers, setUser } from "redux/messageSlice";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(true);
    const [all_users, setAll_users] = useState([]);
    const [Localuser, setLocaluser] = useState(null);

    const [fetchUsers] = useLazyQuery(GET_ALL_USERS, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setLoader(false);
            setAll_users(data?.users?.filter(v => v.role !== 'Public User') || []);
            dispatch(setAllUsers(data?.users?.filter(v => v.role !== 'Public User') || []));
        }
    });

    useQuery(GET_ME, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setLocaluser(data.me);
            dispatch(setUser(data.me));
        }
    });

    useEffect(() => {
        if (Localuser?.company_id) {
            setLoader(true);
            fetchUsers({ variables: { company_id: Localuser.company_id } });
        }
    }, [Localuser, fetchUsers]);


    const contextValue = useMemo(() => ({
        loader,
        all_users,
        setAll_users,
        user: Localuser,
        setUser: setLocaluser,
        fetchUsers
    }), [loader, all_users, Localuser, fetchUsers]);

    return (
        <AdminContext.Provider value={contextValue}>
            {children}
        </AdminContext.Provider>
    );
};

export const useAdmin = () => {
    const context = useContext(AdminContext);
    if (!context) {
        throw new Error("useAdmin must be used within a AdminProvider");
    }
    return context;
};